import { render, staticRenderFns } from "./BotBoundPOS.html?vue&type=template&id=52001d7f&scoped=true&"
import script from "./BotBoundPOS.js?vue&type=script&lang=js&"
export * from "./BotBoundPOS.js?vue&type=script&lang=js&"
import style0 from "./BotBoundPOS.scss?vue&type=style&index=0&id=52001d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52001d7f",
  null
  
)

export default component.exports